<template>
  <div class="map-container">
    <div class="map">
      <GoogleMap
        :api-key="apiKey"
        :center="center"
        :zoom="zoom"
        style="width:100%;  height: 500px;"
      >
        <MarkerCluster>
          <Marker
            :key="index"
            v-for="(m, index) in markers"
            :options="{ position: m.position, label: m.label}"
            @click="toggleInfo(m, index)"
          >
            <InfoWindow
              :options="{ position: infoPosition }"
            >
              <div v-html="infoContent"></div>
            </InfoWindow>
          </Marker>
        </MarkerCluster>
      </GoogleMap>
    </div>
  </div>
</template>

<script>
import { filter, difference, uniqBy, groupBy, forEach } from "lodash-es"
import { GoogleMap, Marker, InfoWindow, MarkerCluster } from 'vue3-google-map'

export default {
  components: {
    GoogleMap,
    Marker,
    InfoWindow,
    MarkerCluster,
  },
  data () {
    return {
      center: {},
      markers: [],
      zoom: 1.8,
      infoPosition: null,
      infoContent: null,
      styles: [{
          url: "/images/m1.png",
          height: 53,
          width: 53,
        },
        {
          url: "/images/m2.png",
          height: 56,
          width: 56,
        },
        {
          url: "/images/m3.png",
          height: 66,
          width: 66,
        },
        {
          url: "/images/m4.png",
          height: 78,
          width: 78,
        },
        {
          url: "/images/m5.png",
          height: 90,
          width: 90,
        },
      ],
    }
  },
  mounted() {
    console.log("the data: ", this.interactiveMapData)

    let data = this.interactiveMapData.filter(x => x.lat != null)
    console.log("here", data)

    let duplicateTCs = difference(data, uniqBy(data, 'lat', 'long'), 'lat', 'long')
    let dupeys = groupBy(data, 'lat', 'long')

    if (data.length != 0) {

      let overallLat = 0
      let overallLong = 0

      data.forEach(i => {
        overallLat += parseFloat(i.lat)
        overallLong += parseFloat(i.long)
      })

      overallLat /= data.length
      overallLong /= data.length

      this.center = {
        lat: overallLat,
        lng: overallLong,
      }

      this.zoom = 2.5

      this.markers = data.map(tc => {
        let pos = {
          lat: parseFloat(tc.lat),
          lng: parseFloat(tc.long),
        }

        let dupes = duplicateTCs.filter(i => i.lat == tc.lat && i.long == tc.long)
        let label = dupes.length + 1

        let info = tc

        info.link = `${location.origin}/training_centers/${tc.id}`

        if (label >= 2) {
          forEach(dupeys, i => {
            if (info.lat == i[0].lat) {
              info.dupes = i
            }
          })
        }

        return {
          position: pos,
          info: info,
          label: label.toString()
        }
      })
    } else {
      this.center = { lat: 0, lng: 0 }
      this.zoom = 1
    }
  },
  methods: {
    toggleInfo (m, index) {
      this.infoPosition = m.position
      this.infoContent = this.getInfoContent(m)
    },
    getInfoContent (m) {

      if (m.info.dupes) {
        let str = ''

        console.log("the dupes: ", m.info.dupes)

        m.info.dupes.forEach(element => {
          str += `Paul: ${element.name} <br>
                  <div style="font-weight: bold;"><a target="_blank" href="${element.link}">View Training Center</a></div> <br>
                  `
        })

        return str
      }

      return `Paul: ${m.info.name} <br>
              Start date: ${m.info.start_date} <br>

              <div style="font-weight: bold;"><a target="_blank" href="${m.info.link}">View Training Center</a></div>
              `
    },
  },
  props: {
    interactiveMapData: {
      type: Array,
    },
    apiKey: {
      type: String,
    },
  }
}
</script>

<style scoped>
</style>
